import { render, staticRenderFns } from "./control-bultos-inicio.vue?vue&type=template&id=275da1c2&scoped=true&"
import script from "./control-bultos-inicio.vue?vue&type=script&lang=ts&"
export * from "./control-bultos-inicio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275da1c2",
  null
  
)

export default component.exports